import { actionCreator } from 'utils';
import * as LayoutTypes from '../types/layoutTypes';


// L A Y O U T   S T U F F
export function setAdmin(admin) {
    return {
        type: LayoutTypes.SET_ADMIN,
        admin,
    };
}

export function toggleCollapsingMenu() {
    return {
        type: LayoutTypes.TOGGLE_COLLAPSING_MENU,
    };
}

export function toggleMobileMenu() {
    return {
        type: LayoutTypes.TOGGLE_MOBILE_MENU,
    };
}

export function switchLocale(locale) {
    return {
        type: LayoutTypes.SWITCH_LOCALE,
        locale,
    };
}
// L A Y O U T   S T U F F


// L O A D   R E S E L L E R
export function loadReseller(urlHostname) {
    return {
        type: LayoutTypes.LOAD_RESELLER,
        urlHostname,
    };
}

export function loadResellerRes(data) {
    return {
        type: actionCreator(LayoutTypes.LOAD_RESELLER, 'res'),
        data,
    };
}

export function loadResellerErr() {
    return {
        type: actionCreator(LayoutTypes.LOAD_RESELLER, 'err'),
    };
}
// L O A D   R E S E L L E R

// E D I T   R E S E L L E R
export function editResellerProfile(data) {
    return {
        type: LayoutTypes.EDIT_RESELLER_PROFILE,
        data,
    };
}

export function editResellerProfileRes(data) {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_PROFILE, 'res'),
        data,
    };
}

export function editResellerProfileErr() {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_PROFILE, 'err'),
    };
}
// E D I T   R E S E L L E R

// E D I T   P R O F I L E
export function editProfile(data) {
    return {
        type: LayoutTypes.EDIT_PROFILE,
        data,
    };
}

export function editProfileRes() {
    return {
        type: actionCreator(LayoutTypes.EDIT_PROFILE, 'res'),
    };
}

export function editProfileErr() {
    return {
        type: actionCreator(LayoutTypes.EDIT_PROFILE, 'err'),
    };
}
// E D I T   P R O F I L E

// E D I T   P R O F I L E   P H O T O
export function editProfilePhoto(data) {
    return {
        type: LayoutTypes.EDIT_PROFILE_PHOTO,
        data,
    };
}

export function editProfilePhotoRes() {
    return {
        type: actionCreator(LayoutTypes.EDIT_PROFILE_PHOTO, 'res'),
    };
}

export function editProfilePhotoErr() {
    return {
        type: actionCreator(LayoutTypes.EDIT_PROFILE_PHOTO, 'err'),
    };
}
// E D I T   P R O F I L E   P H O T O

// E D I T   R E S E L L E R   P H O T O
export function editResellerPhoto(data) {
    return {
        type: LayoutTypes.EDIT_RESELLER_PHOTO,
        data,
    };
}

export function editResellerPhotoRes() {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_PHOTO, 'res'),
    };
}

export function editResellerPhotoErr() {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_PHOTO, 'err'),
    };
}
// E D I T   R E S E L L E R   P H O T O

// E D I T   R E S E L L E R   F A V I C O N
export function editResellerFavicon(data) {
    return {
        type: LayoutTypes.EDIT_RESELLER_FAVICON,
        data,
    };
}

export function editResellerFaviconRes() {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_FAVICON, 'res'),
    };
}

export function editResellerFaviconErr() {
    return {
        type: actionCreator(LayoutTypes.EDIT_RESELLER_FAVICON, 'err'),
    };
}
// E D I T   R E S E L L E R   F A V I C O N

// U S E R   L O G I N
export function userLogin(data) {
    return {
        type: LayoutTypes.USER_LOGIN,
        data,
    };
}

export function userLoginRes(data) {
    return {
        type: actionCreator(LayoutTypes.USER_LOGIN, 'res'),
        data,
    };
}

export function userLoginErr() {
    return {
        type: actionCreator(LayoutTypes.USER_LOGIN, 'err'),
    };
}
// U S E R   L O G I N

// U S E R   D A T A
export function getUserData(data) {
    return {
        type: LayoutTypes.GET_USER_DATA,
        data,
    };
}

export function getUserDataRes(data) {
    return {
        type: actionCreator(LayoutTypes.GET_USER_DATA, 'res'),
        data,
    };
}

export function getUserDataErr() {
    return {
        type: actionCreator(LayoutTypes.GET_USER_DATA, 'err'),
    };
}
// U S E R   D A T A


// U S E R   L O G O U T
export function userLogout(event) {
    return {
        type: LayoutTypes.USER_LOGOUT,
        event,
    };
}

export function userLogoutRes(data) {
    return {
        type: actionCreator(LayoutTypes.USER_LOGOUT, 'res'),
        data,
    };
}

export function userLogoutErr() {
    return {
        type: actionCreator(LayoutTypes.USER_LOGOUT, 'err'),
    };
}
// U S E R   L O G O U T

// U S E R   R E F R E S H   D A T A
export function refrechUserData() {
    return {
        type: LayoutTypes.USER_DATA_REFRESH,
    };
}

export function refrechUserDataRes(data) {
    return {
        type: actionCreator(LayoutTypes.USER_DATA_REFRESH, 'res'),
        data,
    };
}

export function refrechUserDataErr() {
    return {
        type: actionCreator(LayoutTypes.USER_DATA_REFRESH, 'err'),
    };
}
// U S E R   R E F R E S H   D A T A


// L O A D   P A R T N E R S
export function loadPartnersLayout() {
    return {
        type: LayoutTypes.LOAD_PARTNERS_LAYOUT,
    };
}

export function loadPartnersLayoutRes(data) {
    return {
        type: actionCreator(LayoutTypes.LOAD_PARTNERS_LAYOUT, 'res'),
        data,
    };
}

export function loadPartnersLayoutErr() {
    return {
        type: actionCreator(LayoutTypes.LOAD_PARTNERS_LAYOUT, 'err'),
    };
}
// L O A D   P A R T N E R S


// L O A D   P A R T N E R S
export function loadResellersLayout() {
    return {
        type: LayoutTypes.LOAD_RESELLERS_LAYOUT,
    };
}

export function loadResellersLayoutRes(data) {
    return {
        type: actionCreator(LayoutTypes.LOAD_RESELLERS_LAYOUT, 'res'),
        data,
    };
}

export function loadResellersLayoutErr() {
    return {
        type: actionCreator(LayoutTypes.LOAD_RESELLERS_LAYOUT, 'err'),
    };
}
// L O A D   P A R T N E R S

//  L O A D   F A V O R I S   O R D E R
export function loadFavorisOrder() {
    return {
        type: LayoutTypes.LOAD_FAVORIS_ORDER,
    };
}

export function loadFavorisOrderRes(data) {
    return {
        type: actionCreator(LayoutTypes.LOAD_FAVORIS_ORDER, 'res'),
        data,
    };
}

export function loadFavorisOrderErr() {
    return {
        type: actionCreator(LayoutTypes.LOAD_FAVORIS_ORDER, 'err'),
    };
}
//  L O A D   F A V O R I S   O R D E R

// P R O D U C T I O N   S T U F F
export function setOperatorMachine(data) {
    return {
        type: LayoutTypes.SET_OPERATOR_MACHINE,
        data,
    };
}

export function setNavigationDate(data) {
    return {
        type: LayoutTypes.SET_NAVIGATION_DATE,
        data,
    };
}
// P R O D U C T I O N   S T U F F


// G L O B A L   S E A R C H
export function initGlobalSearch() {
    return {
        type: LayoutTypes.INIT_GLOBAL_SEARCH,
    };
}

export function setGlobalSearchSectionTab(tab) {
    return {
        type: LayoutTypes.SET_GLOBAL_SEARCH_SECTION_TAB,
        tab,
    };
}

export function setGlobalSearchSectionCount(data) {
    return {
        type: LayoutTypes.SET_GLOBAL_SEARCH_SECTION_COUNT,
        data,
    };
}
// G L O B A L   S E A R C H

// L O A D   R E S E L L E R S   F O R   T R A N S L A T I O N S
export function setResellerForTranslations(id) {
    return {
        type: LayoutTypes.SET_RESELLER_FOR_TRANSLATIONS,
        id,
    };
}
// L O A D   R E S E L L E R S   F O R   T R A N S L A T I O N S
